import React from "react";

export type StatTone = "ok" | "bad" | "warn" | "muted";

/**
 * Small labelled statistic tile used in both the live progress panel and the
 * terminal summary. Presentational only.
 */
export function Stat({
  label,
  value,
  tone,
  testId,
}: {
  label: string;
  value: number;
  tone: StatTone;
  testId: string;
}) {
  const cls =
    tone === "ok"
      ? "text-emerald-800"
      : tone === "bad"
      ? "text-rose-800"
      : tone === "warn"
      ? "text-amber-800"
      : "text-slate-700";
  return (
    <div
      className="rounded-md border border-slate-200 bg-white p-2"
      data-testid={testId}
      data-tone={tone}
    >
      <div className="text-[10px] uppercase tracking-widest text-slate-500">
        {label}
      </div>
      <div className={`text-lg font-semibold ${cls}`}>{value}</div>
    </div>
  );
}
